import {isPlainObj} from 'ramda-adjunct';

import {CustomParameter, Parameter} from '../types/Parameter';

export function isCustomParameter(parameter: Parameter): parameter is CustomParameter {
  return isPlainObj(parameter);
}
